import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { OrderTypeListSelect } from '../../../../../../components/orders/order-type-list-select';
import { MutualFundsFundOrderSubmitDrawer } from '../../../../../../features/mutual-funds/fund-order/mutual-funds-fund-order-submit-drawer';
import { MutualFundsFundOrdersTable } from '../../../../../../features/mutual-funds/fund-order/mutual-funds-fund-orders-table';
import { getPageHead } from '../../../../../../util/routing/meta';
import { useRollupViewContext } from '../../../../../../util/view-context';

export const Route = createFileRoute('/_app/_clearing-core/order/mutual-fund/_mutual-fund/')({
  head: () => getPageHead('Mutual Fund Orders'),
  component: MutualFundOrderList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <HorizontalStack align="space-between" blockAlign="center" gap={2} wrap="nowrap">
      <OrderTypeListSelect orderType="mutual-fund" />

      <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
        <RequiresAccess write>
          <MutualFundsFundOrderSubmitDrawer
            trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Mutual Fund Order" size="small" />}
          />
        </RequiresAccess>

        {filter}
      </HorizontalStack>
    </HorizontalStack>
  );
}

function MutualFundOrderList() {
  const viewContext = useRollupViewContext();

  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <MutualFundsFundOrdersTable HeaderActions={TableHeader} viewContext={viewContext} />
      </PageLayout.Section>
    </PageLayout>
  );
}
